import ModalResponsive from '@/components/commons/modal-responsive';
import { Card, CardContent } from '@/components/ui/card';
import { cn } from '@/lib/utils';
import { ThemeColorSchemeType } from '@/stores/builder';
import { BaseCustomerAddress } from '@/types/http/customer/common';
import { Form, Formik } from 'formik';
import { MapPin } from 'lucide-react';
import React from 'react';

type ModalSelectAddressProps = {
  openModal: boolean;
  setOpenModal: (open: boolean) => void;
  data: BaseCustomerAddress[];
  colorScheme?: ThemeColorSchemeType;
  onSelect?: (address: BaseCustomerAddress) => void;
};

export default function ModalSelectAddress({
  openModal,
  setOpenModal,
  data,
  colorScheme,
  onSelect,
}: ModalSelectAddressProps) {
  const [selectedAddress, setSelectedAddress] = React.useState<BaseCustomerAddress | null>(null);

  const handleSelectAddress = (address: BaseCustomerAddress) => {
    setSelectedAddress(address);
    if (onSelect) onSelect(address);
    setOpenModal(false);
  };

  React.useEffect(() => {
    if (data) {
      const defaultAddress = data.find((item) => item.is_default);
      setSelectedAddress(defaultAddress as BaseCustomerAddress);
    }
  }, [data]);

  return (
    <>
      <ModalResponsive
        openModal={openModal}
        setOpenModal={setOpenModal}
        title='Select Address'
        className='theme_font max-w-md'
      >
        <Formik validationSchema={null} initialValues={{}} onSubmit={() => {}}>
          {() => (
            <>
              <Form className='max-h-[400px] overflow-y-auto px-6 py-3 pb-5'>
                <div className='flex flex-col gap-2'>
                  {data &&
                    data?.map((item) => (
                      <Card
                        role='button'
                        key={item.id}
                        onClick={() => handleSelectAddress(item)}
                        className={cn('rounded-lg border transition-colors')}
                        style={
                          selectedAddress?.id === item.id
                            ? {
                                backgroundColor: colorScheme?.btnSolidBackgroud,
                                color: colorScheme?.btnSolidlabel,
                              }
                            : { cursor: 'pointer' }
                        }
                      >
                        <CardContent className='p-4'>
                          <h3 className='text-sm font-semibold'>
                            {item.first_name} {item.last_name}
                          </h3>
                          <p className='text-sm'>{item.phone}</p>
                          <p className='mt-1 text-sm'>{item.address}</p>
                          {item.pinpoint && (
                            <div
                              className='mt-2 flex items-center gap-1'
                              style={
                                selectedAddress?.id === item.id
                                  ? {
                                      color: colorScheme?.background,
                                    }
                                  : {
                                      color: colorScheme?.btnSolidBackgroud,
                                    }
                              }
                            >
                              <MapPin className='h-4 w-4' />
                              <span className='text-xs'>Pinpoint Added</span>
                            </div>
                          )}
                        </CardContent>
                      </Card>
                    ))}
                </div>
              </Form>
            </>
          )}
        </Formik>
      </ModalResponsive>
    </>
  );
}
